import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CircleAnnouncement from '../index';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import anime from 'animejs';
import dataModel from '../../../../models/DataModel';
import './NotificationsAnnouncementCircleAnnouncement.scss';

/**
 * NotificationsAnnouncementCircleAnnouncement is a <CircleGlobalModal> which is used to display an initial
 * fullscreen push notifications announcement/overlay to the user. Users should only see this once.
 */
export class NotificationsAnnouncementCircleAnnouncement extends Component {

  constructor(props) {

    NotificationsAnnouncementCircleAnnouncement.propTypes = {
      /** onClose - Function called by the parent when the modal is closed */
      onClose: PropTypes.func,
      modalType: PropTypes.string,
    };

    super(props);
    this.state = {
      status: null,
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    
    this.handleClose = this.handleClose.bind(this);
    this.expandAnnouncement = this.expandAnnouncement.bind(this);
    this.collapseAnnouncement = this.collapseAnnouncement.bind(this);
  }

  componentDidMount() {
    setTimeout(() => { 
      this.expandAnnouncement();
    }, 5000);
  }

  expandAnnouncement() {
    if (!dataModel.mobileBridge.isMobile) {
      return anime({
        targets: `#${this.props.modalType}`,
        translateY: 312,
        translateX: -312,
        easing: 'easeInOutCubic',
        duration: 1000,
      });
    }
    else {
      return anime({
        targets: `#${this.props.modalType}`,
        translateY: -220,
        translateX: -220,
        easing: 'easeInOutCubic',
        duration: 1000,
      });
    }
  }

  collapseAnnouncement() {
    if (!dataModel.mobileBridge.isMobile) {
      return anime({
        targets: `#${this.props.modalType}`,
        translateY: -312,
        translateX: 312,
        easing: 'easeInOutCubic',
        duration: 1000,
        complete: () => {
          this.handleClose();
        },
      });
    }
    else{
      return anime({
        targets: `#${this.props.modalType}`,
        translateY: 220,
        translateX: 220,
        easing: 'easeInOutCubic',
        duration: 1000,
        complete: () => {
          this.handleClose();
        },
      });
    }
  }

  handleClose() {
    let { currentUser } = this.props;
    if (!currentUser.settings) {
      currentUser.settings = {};
    }
    if (!dataModel.mobileBridge.isMobile) {
      currentUser.settings.has_viewed_web_notifications_announcement = true;
    }
    else {
      currentUser.settings.has_viewed_mobile_notifications_announcement = true;
    }
    const updateUser = _.cloneDeep(currentUser);
    dataModel.usersDAO.updateUser(updateUser);
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {

    let bodyText = 'Set how you want to get notified. Click on your name and choose Settings to get started.';
    let swoopArrow = null;
    if (dataModel.mobileBridge.isMobile) {
      bodyText = 'To set how you want to get notified, go to the Settings menu and get started!';
      swoopArrow = <div className="swoop-arrow"/>;
    }

    return (
      <div className={'notifications-announcement-circle-announcement ' + this.props.modalType} id={this.props.modalType}>
        <CircleAnnouncement
          headingText='Updated Notifications!'
          bodyText={bodyText}
          buttonText="GOT IT"
          onClose={this.collapseAnnouncement}
          swoopArrow={swoopArrow}
        >
        </CircleAnnouncement>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(NotificationsAnnouncementCircleAnnouncement);



// WEBPACK FOOTER //
// ./src/components/modals/CircleAnnouncement/NotificationsAnnouncementCircleAnnouncement/index.js